import { MsalProvider } from "@azure/msal-react";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { createBrowserHistory } from "history";
import React, { useEffect, useState } from "react";
import {
  Route,
  BrowserRouter as Router,
  Switch,
  useHistory,
} from "react-router-dom";
import "./App.css";
import FeedbackData from "./function-components/FeedbackData";
import Footer from "./function-components/Footer";
import Navbarmenu from "./function-components/Navbarmenu";
import { PageLayout } from "./function-components/PageLayout";
import SearchNav from "./function-components/Searchnav";
import Sponsors from "./function-components/SponsorsContent";
import APIAutomation from "./pages/APIautomation";
import Azure from "./pages/Azure";
import Dashboard from "./pages/Dashboard";
import Reviews from "./function-components/Reviews";
import FAQ from "./pages/FAQ";
import Home from "./pages/Home";
import ManualTesting from "./pages/ManualTesting";
import Powerbi from "./pages/Powerbi";
import Python from "./pages/Python";
import SRE from "./pages/SRE";
import SapFieldglass from "./pages/SapFieldglass";
import SapFinance from "./pages/SapFinance";
import SapMM from "./pages/SapMM";
import TOSCA from "./pages/TOSCA";
import { CustomNavigationClient } from "./utils/NavigationClient";
import AnalyticsPage from "./analytics/AnalyticsPage";
// import { useMsal } from "@azure/msal-react";
import AccessDenied from "./function-components/AccessDenied";
import AdminPage from "./function-components/Admin/AdminPage";
import { useDispatch, useSelector } from "react-redux";
import { getUsers } from "./function-components/Redux/UsersSlice";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";

function App({ pca }) {
  // The next 3 lines are optional. This is how you configure MSAL to take advantage of the router's navigate functions when MSAL redirects between pages in your app
  const history = useHistory();
  const navigationClient = new CustomNavigationClient(history);

  pca.setNavigationClient(navigationClient);

  return (
    <MsalProvider instance={pca}>
      <PageLayout>
        <div container justifyContent="center">
          <Pages />
        </div>
      </PageLayout>
    </MsalProvider>
  );
}
var reactPlugin = new ReactPlugin();
const browserHistory = createBrowserHistory({ basename: "/" });

var appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: "056c4eba-558d-42f8-9528-e8b102587cb8",
    enableAutoRouteTracking: true,
    extensions: [reactPlugin],
    extensionConfig: {
      [reactPlugin.identifier]: { history: browserHistory },
    },
  },
});
appInsights.loadAppInsights();

function Pages() {
  const msalInstance = new PublicClientApplication(msalConfig);
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  const [token, setToken] = useState(null);

  useEffect(() => {
    console.log("0");
    if (activeAccount) {
      console.log("1");
      fetchAccessToken();
      console.log("2");
    }
  }, [activeAccount]);
  const fetchAccessToken = async () => {
    if (!activeAccount)
      throw Error(
        "No active account! Verify a user has been signed in and setActiveAccount has been called."
      );
    try {
      console.log(activeAccount, "active acc check");
      const response = await msalInstance.acquireTokenSilent({
        ...loginRequest,
        account: activeAccount,
      });
      const bearer = `Bearer ${response.accessToken}`;
      console.log(bearer);
      console.log("inside fetch func");
      localStorage.setItem("token", bearer);
      setToken(bearer);
      // dispatch(getUsers(bearer));
      console.log("inside try block");
    } catch (error) {
      console.error("Error fetching access token:", error);
      localStorage.clear();
    }
  };

  //----------------------------------------------------------------------------
  const dispatch = useDispatch();
  const usersData = useSelector((state) => state.users.usersData);

  // const { instance } = useMsal();
  // const activeAccount = instance.getActiveAccount();
  let loggedInEnterpriseId = "";
  let loggedInUsername = "";
  if (activeAccount) {
    loggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;
    loggedInUsername = activeAccount.name;
  }
  console.log(loggedInUsername, "active accccc");
  let temp = loggedInUsername.split(",");
  let finalUsername = temp[1] + " " + temp[0];
  finalUsername = finalUsername.trim();
  // console.log(finalUsername, "finalll");

  useEffect(() => {
    console.log(token, "hi token");
    dispatch(getUsers());
    console.log("get users called");
  }, [token]);

  const allowedTeamMembers = [
    "aayushi.bharti",
    "akshata.bhau.malvi",
    "aluru.akash",
    "arpita.m.singh",
    "d.d.choudhary",
    "d.kumari.vaishnava",
    "h.srinivasan",
    "j.b.bhardwaj",
    "jeevadharani.ramanan",
    "lavanya.umesh",
    "manasa.h.n",
    "manoj.kumar.swain",
    "medha.sundriyal",
    "reshmi.haridas.m",
    "shramika.s.ambolkar",
    "shubham.bl.kumar",
    "sucharitha.karanam",
    "uma.rani.battu",
    "varsha.a.tyagi",
    "vinay.a.kumar.dubey",
    "ankur.e.mishra",
    "shubham.i.tyagi",
    "srikanth.narabathoju",
  ];

  const allowedUsers = Array.isArray(usersData)
    ? usersData
        .filter((item) => item.isActive?.toLowerCase() === "yes")
        .map((item) => item.EnterpriseID)
    : [];
  // {console.log(allowedUsers, "allowedddd usersss")}
  return (
    <>
      {allowedUsers
        .concat(allowedTeamMembers)
        .includes(loggedInEnterpriseId) ? (
        <Router basename={"/"}>
          <SearchNav />
          <Navbarmenu />
          <Switch>
            <Route exact path="/home">
              <Home />
            </Route>
            <Route exact path="/">
              <Home />
            </Route>
            <Route exact path="/faq">
              <FAQ />
            </Route>
            <Route exact path="/feedback">
              <FeedbackData />
            </Route>
            <Route exact path="/Azure">
              <Azure />
            </Route>
            <Route exact path="/SapFinance">
              <SapFinance />
            </Route>
            <Route exact path="/SapFieldglass">
              <SapFieldglass />
            </Route>
            <Route exact path="/sponsors">
              <Sponsors />
            </Route>
            <Route exact path="/API-Automation-Testing">
              <APIAutomation />
            </Route>
            <Route exact path="/TOSCA">
              <TOSCA />
            </Route>
            <Route exact path="/ManualTesting">
              <ManualTesting />
            </Route>
            <Route exact path="/SRE">
              <SRE />
            </Route>
            <Route exact path="/Python">
              <Python />
            </Route>
            <Route exact path="/PowerBI">
              <Powerbi />
            </Route>
            <Route exact path="/SapMM">
              <SapMM />
            </Route>
            <Route exact path="/dashboard">
              <Dashboard />
            </Route>
            <Route exact path="/analytics">
              <AnalyticsPage />
            </Route>
            <Route exact path="/reviews">
              <Reviews />
            </Route>
            <Route exact path="/userMaintenance">
              <AdminPage />
            </Route>
          </Switch>
          <Footer />
        </Router>
      ) : (
        <AccessDenied
          loggedInEnterpriseId={loggedInEnterpriseId}
          finalUsername={finalUsername}
        />
      )}
    </>
  );
}

export default App;
